define.alias("ember-composable-helpers/helpers/flatten", "settings/helpers/flatten");